module.exports = __webpack_public_path__ + "img/allhouse.4449a8fc.svg";